import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/community/residential/area/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/residential/area/detail', Object.assign({}, options, { params }))
export const residentialarealist = (params, options) =>
request.get('/api/v4ward/community/residential/area/list', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/residential/area/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/residential/area/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/residential/area/update', params,options)
